var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticStyle: { "enable-background": "new 0 0 140.9 101.7" },
      attrs: {
        version: "1.1",
        id: "Ebene_3",
        xmlns: "http://www.w3.org/2000/svg",
        x: "0px",
        y: "0px",
        height: "101",
        width: "140",
        viewBox: "0 0 140.9 101.7",
        "xml:space": "preserve",
      },
    },
    [
      _c("circle", {
        staticClass: "st0",
        attrs: { cx: "40.3251", cy: "58.2295", r: "4.0962" },
      }),
      _vm._v(" "),
      _c("circle", {
        staticClass: "st0",
        attrs: { cx: "62.1424", cy: "58.2295", r: "4.0962" },
      }),
      _vm._v(" "),
      _c("path", { staticClass: "st0", attrs: { d: "M90.8,85.5" } }),
      _vm._v(" "),
      _c("path", {
        staticClass: "st0",
        attrs: {
          d: "M35.4355,90.7989h97.067v-22.894c-0.015,0.0001-0.0294,0.0023-0.0444,0.0023\n\tc-9.4255,0-17.0663-7.6409-17.0663-17.0663s7.6408-17.0663,17.0663-17.0663c0.015,0,0.0294,0.0022,0.0444,0.0023v-22.894H8.3948\n\tv79.9162h15.1389",
        },
      }),
      _vm._v(" "),
      _c("line", {
        staticClass: "st0",
        attrs: { x1: "90.8", y1: "10.8919", x2: "90.8", y2: "90.7989" },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "st0",
        attrs: {
          d: "M62.0518,19.8983h3.877c5.4491,0,9.8665,4.4174,9.8665,9.8665v31.9568c0,5.4491-4.4174,9.8665-9.8665,9.8665\n\tH36.7452c-5.4491,0-9.8665-4.4174-9.8665-9.8665V29.7648c0-5.4491,4.4174-9.8665,9.8665-9.8665H54.335",
        },
      }),
      _vm._v(" "),
      _c("path", {
        staticClass: "st0",
        attrs: {
          d: "M62.9595,48.8867H39.506c-2.5613,0-4.6377-2.0764-4.6377-4.6377V33.8167c0-2.5613,2.0764-4.6377,4.6377-4.6377\n\th23.4536c2.5614,0,4.6377,2.0764,4.6377,4.6377V44.249C67.5973,46.8104,65.5209,48.8867,62.9595,48.8867z",
        },
      }),
      _vm._v(" "),
      _c("g", [
        _c("line", {
          staticClass: "st0",
          attrs: { x1: "36.5387", y1: "71.5881", x2: "30.0943", y2: "81.6207" },
        }),
        _vm._v(" "),
        _c("line", {
          staticClass: "st0",
          attrs: { x1: "66.1353", y1: "71.5881", x2: "72.5798", y2: "81.6207" },
        }),
        _vm._v(" "),
        _c("line", {
          staticClass: "st0",
          attrs: { x1: "32.6527", y1: "77.6377", x2: "69.3454", y2: "77.6377" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }